import React, {FC} from "react";
import {Card, Col, Form, Row} from "react-bootstrap";
import {useFormikContext} from "formik";
import {GoalRewardType} from "@interfaces/consumer/refs";
import {GoalRewardFormValues} from "./rewardBaseInfoBlock";

const RewardTypeBlock: FC = () => {
    const {values, setFieldValue} = useFormikContext<GoalRewardFormValues>();

    return (
        <Card className="mb-3">
            <Card.Header as="h6" className="bg-body-tertiary">Тип награды</Card.Header>
            <Card.Body>
                <Form.Group as={Row} className="mb-3">
                    <Form.Label column sm={3}>Тип</Form.Label>
                    <Col sm={9}>
                        <Form.Check
                            type="radio"
                            name="type"
                            id="reward-type-balance"
                            label="Баланс"
                            checked={values.type === GoalRewardType.Balance}
                            onChange={() => setFieldValue('type', GoalRewardType.Balance)}
                        />
                        <Form.Check
                            type="radio"
                            name="type"
                            id="reward-type-item"
                            label="Предмет"
                            checked={values.type === GoalRewardType.Item}
                            onChange={() => setFieldValue('type', GoalRewardType.Item)}
                        />
                    </Col>
                </Form.Group>
            </Card.Body>
        </Card>
    );
};

export default RewardTypeBlock;
